import { createFileRoute, redirect } from "@tanstack/react-router";
import { AUTH_ROUTE } from "@/shared/lib/routes";
import { OnboardingConversationPage } from "@/pages/onboarding-conversation";

export const Route = createFileRoute("/onboarding/company-setup")({
  component: OnboardingConversationPage,
  beforeLoad: ({ context }) => {
    if (!context.me) throw redirect({ to: AUTH_ROUTE });

    const hasCompletedOnboarding = (context.me.companies ?? []).some(
      (c) => c.onboardingCompletedAt,
    );
    if (hasCompletedOnboarding) throw redirect({ to: "/" });
  },
});
